// Interiorismo adaptation of the review theme's sample-selector.js.
// Shopify cart is the source of truth; no dependency on theme.js or private storage.
(function () {
  'use strict';

  function initSampleStudio(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var variantId = Number(root.dataset.sampleVariantId || 0);
    var variantAvailable = root.dataset.sampleVariantAvailable === 'true';
    var maxSamples = Math.min(3, Math.max(1, Number(root.dataset.sampleMax) || 3));
    var unitPrice = Number(root.dataset.sampleUnitPrice);
    var currency = root.dataset.sampleCurrency || 'USD';
    var creditDays = root.dataset.sampleCreditDays || '90';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sample-card]'));
    var familyButtons = Array.prototype.slice.call(root.querySelectorAll('.sample-studio__family[data-sample-family]'));
    var selection = root.querySelector('.sample-studio__selection');
    var counter = root.querySelector('[data-sample-counter]');
    var selectionHint = root.querySelector('.sample-studio__selection-hint');
    var selectionTotal = root.querySelector('[data-sample-selection-total]');
    var selectionLink = root.querySelector('[data-sample-selection-link]');
    var originLink = root.querySelector('[data-sample-origin-link]');
    var originLabel = root.querySelector('[data-sample-origin-label]');
    var catalogTitle = root.querySelector('[data-sample-catalog-title]');
    var catalogCount = root.querySelector('[data-sample-catalog-count]');
    var status = root.querySelector('[data-sample-status]');
    var retry = root.querySelector('[data-sample-retry]');
    var query = new URLSearchParams(window.location.search);
    var requestedHandle = (query.get('muestra') || '').trim().toLowerCase();
    var requestedCard = cards.find(function (card) { return card.dataset.sampleHandle === requestedHandle; });
    var activeFamily = requestedCard ? requestedCard.dataset.sampleFamily : query.get('familia') === 'vinilico' ? 'vinyl' : query.get('familia') === 'wall-panels' ? 'wall' : 'wood';
    var cart = null;
    var cartReady = false;
    var pending = true;
    var action = null;
    var refreshQueued = false;
    var refreshPromise = null;
    var source = 'interiorismo-samples';

    function route(path) {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return rootPath.replace(/\/?$/, '/') + path.replace(/^\//, '');
    }

    function canonicalMaterialUrl(value) {
      try {
        var url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !/^(?:\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)(?:\/|$)|\/$)/i.test(url.pathname)) return null;
        url.searchParams.delete('view');
        return url.pathname + url.search + url.hash;
      } catch (_) { return null; }
    }

    var customOrigin = canonicalMaterialUrl(query.get('origen_url') || '');
    var customOriginLabel = (query.get('origen_label') || '').replace(/\s+/g, ' ').trim().slice(0, 120);
    if (!query.get('origen_url')) customOrigin = null;

    cards.forEach(function (card) {
      var normalized = canonicalMaterialUrl(card.dataset.sampleUrl || '/products/' + card.dataset.sampleHandle);
      if (normalized) card.dataset.sampleUrl = normalized;
      if (card === requestedCard) {
        var requestedVariant = query.get('variant');
        if (requestedVariant && /^[1-9]\d*$/.test(requestedVariant)) {
          var url = new URL(card.dataset.sampleUrl, window.location.origin);
          url.searchParams.set('variant', requestedVariant);
          card.dataset.sampleUrl = url.pathname + url.search + url.hash;
        }
        if (customOrigin) {
          var original = new URL(customOrigin, window.location.origin);
          var cardUrl = new URL(card.dataset.sampleUrl, window.location.origin);
          if (original.pathname === cardUrl.pathname && /^[1-9]\d*$/.test(original.searchParams.get('variant') || '')) {
            cardUrl.searchParams.set('variant', original.searchParams.get('variant'));
            card.dataset.sampleUrl = cardUrl.pathname + cardUrl.search + cardUrl.hash;
          }
        }
      }
      card.querySelectorAll('[data-sample-product-link]').forEach(function (link) {
        var url = canonicalMaterialUrl(link.getAttribute('href') || card.dataset.sampleUrl);
        if (card === requestedCard || !url) url = card.dataset.sampleUrl;
        if (url) link.href = url;
      });
    });

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function sampleLines() {
      if (!cart || !Array.isArray(cart.items)) return [];
      return cart.items.filter(function (item) { return Number(item.variant_id) === variantId; });
    }

    function sampleCount() {
      return sampleLines().reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
    }

    function lineMatchesCard(item, card) {
      var properties = item.properties || {};
      var checks = [
        ['_sample_key', card.dataset.sampleKey],
        ['_sample_source_handle', card.dataset.sampleHandle],
        ['_Producto', card.dataset.sampleHandle],
        ['Código', card.dataset.sampleCode],
        ['Muestra', card.dataset.sampleTitle]
      ];
      // Prefer stable identifiers. A repeated display name must not remove another design.
      for (var index = 0; index < checks.length; index += 1) {
        var pair = checks[index];
        if (pair[1] && properties[pair[0]]) return properties[pair[0]] === pair[1];
      }
      return false;
    }

    function isCardAdded(card) {
      return sampleLines().some(function (item) { return lineMatchesCard(item, card); });
    }

    function syncCards() {
      var count = sampleCount();
      cards.forEach(function (card) {
        var button = card.querySelector('[data-sample-add]');
        var label = card.querySelector('[data-sample-add-label]');
        var icon = card.querySelector('[data-sample-add-icon]');
        if (!button || !label) return;
        var added = isCardAdded(card);
        var title = card.dataset.sampleTitle || 'este diseño';
        card.classList.toggle('is-added', added);
        button.disabled = pending || !cartReady || !variantId || (!added && (!variantAvailable || count >= maxSamples));
        button.setAttribute('aria-pressed', String(added));
        button.setAttribute('aria-busy', String(pending || !cartReady));
        if (action && action.card === card) label.textContent = action.remove ? 'Quitando…' : 'Agregando…';
        else if (!cartReady) label.textContent = pending ? 'Cargando…' : 'Revisar selección';
        else if (added) label.textContent = 'Quitar';
        else if (!variantAvailable || !variantId) label.textContent = 'No disponible';
        else if (count >= maxSamples) label.textContent = 'Máximo alcanzado';
        else label.textContent = 'Agregar';
        button.setAttribute('aria-label', !cartReady ? 'Verificar la selección antes de elegir ' + title : (added ? 'Quitar muestra de ' : 'Agregar muestra de ') + title);
        if (icon) icon.textContent = added ? '×' : !cartReady || count >= maxSamples ? '' : '+';
      });
      if (counter) {
        counter.textContent = cartReady ? count + ' de ' + maxSamples + (count === 1 ? ' seleccionada' : ' seleccionadas') : pending ? 'Cargando selección…' : 'Selección por verificar';
        counter.dataset.compact = cartReady ? count + '/' + maxSamples : '…';
      }
      if (selection) selection.dataset.hasSelection = String(count > 0);
      if (selectionHint) selectionHint.textContent = !cartReady ? 'Verificando carrito' : count >= maxSamples ? 'Selección completa' : 'Elegí hasta ' + maxSamples;
      if (selectionTotal) {
        selectionTotal.hidden = !cartReady || count === 0 || !Number.isFinite(unitPrice);
        var total = Number.isFinite(unitPrice) ? unitPrice * count / 100 : 0;
        selectionTotal.textContent = currency + ' ' + (Number.isInteger(total) ? total : total.toFixed(2)) + ' + IVA';
      }
      if (selectionLink) selectionLink.hidden = cartReady && count === 0;
      if (retry) { retry.hidden = cartReady; retry.disabled = pending; }
      root.setAttribute('aria-busy', String(pending));
    }

    function syncFamily() {
      if (!['wood', 'vinyl', 'wall'].includes(activeFamily)) activeFamily = 'wood';
      var visible = 0;
      cards.forEach(function (card) {
        var show = card.dataset.sampleFamily === activeFamily;
        card.hidden = !show;
        if (show) visible += 1;
      });
      familyButtons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.sampleFamily === activeFamily)); });
      if (catalogTitle) catalogTitle.textContent = activeFamily === 'wood' ? 'Madera natural' : activeFamily === 'vinyl' ? 'Pisos vinílicos' : 'Wall Panels';
      if (catalogCount) catalogCount.textContent = visible + (visible === 1 ? ' diseño' : ' diseños');
      if (originLink) {
        var origin = customOrigin && customOriginLabel ? { label: customOriginLabel, url: customOrigin }
          : requestedCard ? { label: requestedCard.dataset.sampleTitle || 'Producto', url: requestedCard.dataset.sampleUrl }
          : query.get('origen') === 'proyecto' ? { label: 'Explorar materiales', url: '/#materiales' }
          : activeFamily === 'vinyl' ? { label: 'Pisos vinílicos', url: '/collections/pisos-vinilicos' }
          : activeFamily === 'wall' ? { label: 'Wall Panels', url: '/collections/wall-panel' }
          : { label: 'Pisos de madera', url: '/collections/pisos-de-madera' };
        originLink.href = origin.url;
        originLink.setAttribute('aria-label', 'Volver a ' + origin.label);
        if (originLabel) originLabel.textContent = origin.label;
      }
    }

    function rememberSampleOrigin(card) {
      try {
        var family = card.dataset.sampleFamily;
        var familyParameter = family === 'vinyl' ? 'vinilico' : family === 'wall' ? 'wall-panels' : 'madera';
        var returnKey = family === 'wall' ? 'mrp:wall-panels' : 'mrp:explorer-return:' + (family === 'vinyl' ? 'vinyl' : 'wood');
        var returnUrl = new URL(window.location.href);
        returnUrl.searchParams.delete('view');
        returnUrl.searchParams.set('familia', familyParameter);
        returnUrl.searchParams.set('muestra', card.dataset.sampleHandle);
        returnUrl.hash = 'muestras-catalogo';
        window.sessionStorage.setItem(returnKey, JSON.stringify({
          url: returnUrl.pathname + returnUrl.search + returnUrl.hash,
          label: 'Volver a elegir muestras',
          productPath: new URL(card.dataset.sampleUrl || '/', window.location.origin).pathname
        }));
      } catch (_) { /* Browsing still works when session storage is unavailable. */ }
    }

    function publishCart() {
      var pubsub = window.theme && window.theme.pubsub;
      if (pubsub && typeof pubsub.publish === 'function' && pubsub.PUB_SUB_EVENTS) {
        try { pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: source, cart: cart }); } catch (_) { /* Native cart events remain available. */ }
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: source, open: false, cart: cart } }));
    }

    async function fetchCart() {
      var response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      var nextCart = await response.json();
      if (!nextCart || !Array.isArray(nextCart.items)) throw new Error('cart');
      cart = nextCart;
      cartReady = true;
      syncCards();
      return nextCart;
    }

    async function writeCart(path, data) {
      var response = await fetch(route(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(data) });
      if (!response.ok) throw new Error(path);
      return response.json();
    }

    function successMessage(card, remove) {
      return (card.dataset.sampleTitle || 'La muestra') + (remove ? ' se quitó de tu selección.' : ' se agregó a tu selección.');
    }

    async function toggleSample(card, button) {
      if (pending || !cartReady || button.disabled || !variantId) return;
      // Preserve the user's action if another tab changes the cart before our fresh read.
      var remove = isCardAdded(card);
      if (!remove && !variantAvailable) return;
      pending = true;
      action = { card: card, remove: remove };
      var attemptedWrite = false;
      setStatus('');
      syncCards();
      try {
        await fetchCart();
        if (remove && !isCardAdded(card)) { publishCart(); setStatus(successMessage(card, true)); return; }
        if (!remove && isCardAdded(card)) { publishCart(); setStatus((card.dataset.sampleTitle || 'La muestra') + ' ya está en tu selección.'); return; }
        if (!remove && sampleCount() >= maxSamples) {
          publishCart();
          setStatus('Ya elegiste el máximo de ' + maxSamples + ' muestras. Quitá una para elegir otro diseño.', true);
          return;
        }
        if (remove) {
          var updates = {};
          sampleLines().filter(function (item) { return lineMatchesCard(item, card); }).forEach(function (item) {
            if (!item.key) throw new Error('Missing cart line key');
            updates[item.key] = 0;
          });
          attemptedWrite = true;
          await writeCart('cart/update.js', { updates: updates });
        } else {
          attemptedWrite = true;
          await writeCart('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: {
            'Muestra': card.dataset.sampleTitle || '',
            'Código': card.dataset.sampleCode || '',
            'Crédito bonificable': root.dataset.sampleCreditLabel || '',
            'Vigencia del crédito': creditDays + ' días',
            '_sample_key': card.dataset.sampleKey || '',
            '_sample_source_handle': card.dataset.sampleHandle || '',
            '_sample_source_url': card.dataset.sampleUrl || '',
            '_sample_family': card.dataset.sampleFamily || '',
            '_Producto': card.dataset.sampleHandle || ''
          } }] });
        }
        cartReady = false;
        await fetchCart();
        publishCart();
        setStatus(successMessage(card, remove));
      } catch (_) {
        cartReady = false;
        if (attemptedWrite) {
          // A lost response can follow a successful write. Reconcile; never retry a POST automatically.
          try {
            await fetchCart();
            publishCart();
            if (isCardAdded(card) !== remove) { setStatus(successMessage(card, remove)); return; }
          } catch (_) { /* Keep actions disabled until the cart can be confirmed. */ }
        }
        setStatus(cartReady ? 'No pudimos ' + (remove ? 'quitar' : 'agregar') + ' la muestra. Probá nuevamente o consultanos.' : 'No pudimos confirmar tu selección. Revisá el carrito o recargá antes de volver a intentarlo.', true);
      } finally {
        action = null;
        pending = false;
        syncCards();
        if (refreshQueued) { refreshQueued = false; refreshCart(); }
      }
    }

    function refreshCart() {
      if (refreshPromise) { refreshQueued = true; return refreshPromise; }
      if (action) { refreshQueued = true; return Promise.resolve(); }
      pending = true;
      syncCards();
      refreshPromise = fetchCart().then(function () { setStatus(''); }).catch(function () {
        cartReady = false;
        setStatus('No pudimos leer tu selección. Revisá el carrito o recargá la página para intentarlo nuevamente.', true);
      }).finally(function () {
        pending = false;
        refreshPromise = null;
        syncCards();
        if (refreshQueued) { refreshQueued = false; refreshCart(); }
      });
      return refreshPromise;
    }

    familyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFamily = button.dataset.sampleFamily || 'wood';
        syncFamily();
        var url = new URL(window.location.href);
        url.searchParams.delete('view');
        url.searchParams.set('familia', activeFamily === 'wood' ? 'madera' : activeFamily === 'vinyl' ? 'vinilico' : 'wall-panels');
        // A later reload must preserve the selected family rather than an earlier product prefill.
        url.searchParams.delete('muestra');
        window.history.replaceState({}, '', url.toString());
      });
    });
    cards.forEach(function (card) {
      var button = card.querySelector('[data-sample-add]');
      if (button) button.addEventListener('click', function () { toggleSample(card, button); });
      card.querySelectorAll('[data-sample-product-link]').forEach(function (link) { link.addEventListener('click', function () { rememberSampleOrigin(card); }); });
    });
    if (retry) retry.addEventListener('click', refreshCart);
    if (requestedCard) requestedCard.classList.add('is-highlighted');
    syncFamily();
    syncCards();
    refreshCart().then(function () {
      if (!requestedCard || !cartReady) return;
      var button = requestedCard.querySelector('[data-sample-add]');
      requestedCard.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
      if (button && !button.disabled) button.focus({ preventScroll: true });
    });
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (event.detail && event.detail.source === source) return;
        refreshCart();
      });
    });
    window.addEventListener('pageshow', refreshCart);
  }

  function boot() { document.querySelectorAll('[data-sample-studio]').forEach(initSampleStudio); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
